import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';
import { REMOTE_SEARCH_ROW_KEY } from 'projects/service/src/app/shared/utils/remote-search-grid-api';

// Serial number advanced search (Service Order and ISC popups) on @inavista/components. Same columns, labels, order,
// widths, alignment and toolbar (Search, Clear filters) as the Syncfusion grid it replaces. Rows come from the same
// endpoints with the same request (RemoteSearchGridApi); 50 rows per request, loaded as the user scrolls. No paging.

export const SERIAL_ADVANCED_SEARCH_PERSISTENCE_KEY = 'rims.service.serial-advanced-search';
export const SERIAL_ADVANCED_SEARCH_URL = 'rims-search://serial-advanced-search';

// SerialNumberSearchViewModel.
export const SERIAL_COLUMNS: [string, string][] = [
  ['serialNumber', 'nvarchar'],
  ['alternateSerialNumber', 'nvarchar'],
  ['model', 'nvarchar'],
  ['modelDescription', 'nvarchar'],
  ['configuration', 'nvarchar'],
  ['customerId', 'nvarchar'],
  ['customerName', 'nvarchar'],
  ['isNationalAccount', 'bit'],
  ['nationalAccount', 'nvarchar'],
];

const ORDER = SERIAL_COLUMNS.map(([c]) => c);

export function buildSerialAdvancedSearchGridConfig(emptyStateMessage: string): GridConfig {
  return {
    apiBaseUrl: SERIAL_ADVANCED_SEARCH_URL,
    keyColumn: REMOTE_SEARCH_ROW_KEY,
    // The old page size.
    pageSize: 50,
    rowHeight: 30,
    defaultColumnOrder: ORDER,
    // National Account (the flag) started hidden and the old toolbar had no column chooser to show it; the row key is ours.
    hiddenByDefaultColumns: ['isNationalAccount', REMOTE_SEARCH_ROW_KEY],
    columnLabels: {
      serialNumber: 'Serial Number', alternateSerialNumber: 'Alternate Serial Number', model: 'Model Number',
      modelDescription: 'Model Description', configuration: 'Configuration', customerId: 'Customer Id',
      customerName: 'Customer Description', isNationalAccount: 'National Account', nationalAccount: 'National Account',
    },
    // Every column left, as the old grid (no textAlign).
    columnAlign: Object.fromEntries(ORDER.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // No column had a width: they shared the grid's width, so they start equal and stretch.
    columnWidths: Object.fromEntries(ORDER.map(c => [c, 130])),
    stretchColumns: true,
    columnTypes: { isNationalAccount: 'boolean' },
    // The old Actions column was 120px wide.
    actionsColumnMinWidth: 120,
    searchHint: 'Searches every column.',
    // The old toolbar: Search and Clear all Filters only.
    enableColumnsPicker: false,
    enableExport: false,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableRefresh: false,
    // Reset layout undoes the layout the grid now remembers (as on the other Service Order popup grids).
    // Ctrl+click adds a sort column, as the old grid (Syncfusion multi-sort; 0.3.42, N80).
    multiSort: true,
    enableResetLayout: true,
    // The footer gives the old "Total Records" count.
    enableFooter: true,
    loadingIndicator: 'banner',
    emptyStateMessage,
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: SERIAL_ADVANCED_SEARCH_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  };
}
